import React, { Component } from 'react';
import IStageComponent, { TStageComponent, TStages } from './IStageComponent';

import * as style from './StageComponentStyles.module.scss'


const TStagesProp: TStages = {
  'pre-listed': 'Pre-listed',
  seeking_funding: 'Seeking Funding',
  funded: 'Funded',
  hidden: 'Hidden',
  trading: 'Trading',
  unsuccessful_pitch: 'Unsuccessful Pitch',
};

export default class StageComponent extends Component<IStageComponent, TStageComponent> {

  state: TStageComponent = {
    stage: this.props.stage || [],
    error: null,
  };

  componentWillReceiveProps(nextProps: IStageComponent) {
    if (nextProps.stage && String(nextProps.stage) !== String(this.props.stage)) {
      this.setState({ stage: nextProps.stage });
    }
  }

  componentDidUpdate(prevProps: IStageComponent, prevState: TStageComponent) {
    if (prevState.stage !== this.state.stage && this.props.updateStateFromChild) {
      this.props.updateStateFromChild('labels', [this.state.stage]);
    }
  }

  selectChange(e:any) {
    this.setState({
      stage: e.target.value,
    });
  }

  renderStageList() {
    return this.state.stage.length > 0 ? (
      <ul className={style.stageList}>
        {this.state.stage.map(stage => (
            <li key={stage} className={style.stageListElement}>
            {TStagesProp[stage]}
            </li>
        ))}
      </ul>
    ) : null;
  }

  render() {
    return (
      <React.Fragment>
        {this.renderStageList()}
      </React.Fragment>
    );
  }
}
